import { useKeycloakAuth } from '@/hooks/useKeycloakAuth';
import { MaintenanceMode } from '@/components/MaintenanceMode';
import { RedirectToKeycloakLogin } from '@/components/RedirectToKeycloakLogin';
import { MAINTENANCE_MODE, MAINTENANCE_TITLE, MAINTENANCE_DESCRIPTION } from '@/config/maintenance';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useKeycloakAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <RedirectToKeycloakLogin />;
  }

  // Verificar modo de manutenção global
  if (MAINTENANCE_MODE) {
    return <MaintenanceMode title={MAINTENANCE_TITLE} description={MAINTENANCE_DESCRIPTION} />;
  }

  return <>{children}</>;
};
